webpackJsonp([203258378304454],{

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Features = __webpack_require__(20);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Features2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Data Structure'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Enables data-driven components by supplying components with both data and context.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Providing the user with visual feedback about what\'s happening in an application is ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'extremely'
	      ),
	      ' important for providing a good user experience. In order to do that, the data components receives needs to be self-describing. That means that no matter what is happening in the application, or what response the API returned for a request, the data structure you use must be able to represent it, so that all the information a component needs in order to know what to render is contained in the data it receives.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There are two data containers in Lore; a ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: './models/' },
	        'model'
	      ),
	      ' and a ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: './collections/' },
	        'collection'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visualization'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This video describes the data structure Lore uses to enable data-driven components.'
	    ),
	    _react2.default.createElement(_Video2.default, { videoId: 'ZRcExHzY9W0' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-data-structure-index-js-32c969cfc761f99cc018.js